module.exports = __webpack_public_path__ + "img/menu_icon.065556a0.svg";